// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var videoWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(20)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateZ("zero")),
      BsCssJs$PrezzeeRibbon.selector("[data-vimeo-url]", [
            BsCssJs$PrezzeeRibbon.position("relative"),
            BsCssJs$PrezzeeRibbon.zIndex(1)
          ]),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.position(BsCssJs$PrezzeeRibbon.absolute),
            BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translate(BsCssJs$PrezzeeRibbon.pct(-50), BsCssJs$PrezzeeRibbon.pct(-50))),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.objectFit("cover")
          ])
    ]);

var ctrlButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(36)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(36)),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.zIndex(3),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.pct(50)),
      BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
      BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.px(31)),
      BsCssJs$PrezzeeRibbon.top("auto"),
      BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateX(BsCssJs$PrezzeeRibbon.pct(-50))),
      BsCssJs$PrezzeeRibbon.pointerEvents("none"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(30)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(30)),
            BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.px(16))
          ]),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.position("absolute"),
            BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(50)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(50)),
            BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgba(255, 255, 255, BsCssJs$PrezzeeRibbon.pct(34))),
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translate(BsCssJs$PrezzeeRibbon.pct(-50), BsCssJs$PrezzeeRibbon.pct(-50))),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
                  BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(40)),
                  BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(40))
                ])
          ])
    ]);

var mobileHeightFiller = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.pct(456 / 228 * 100))])]);

var Style = {
  videoWrapper: videoWrapper,
  ctrlButton: ctrlButton,
  mobileHeightFiller: mobileHeightFiller
};

function VideoTextPromoBlock__Video(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      props.children,
                      JsxRuntime.jsx("span", {
                            children: JsxRuntime.jsx("span", {}),
                            className: ctrlButton
                          })
                    ],
                    className: Classnames([
                          videoWrapper,
                          className$1
                        ])
                  })
            });
}

var make = VideoTextPromoBlock__Video;

export {
  Style ,
  make ,
}
/* videoWrapper Not a pure module */
